module.exports = __webpack_public_path__ + "static/media/bg.b155488d.jpg";